import React from "react";
import img from '../data/transparent.png'
import { socials } from "../data/data";


export default function About() {
    return (
        <section id="about">
            <div className="container mx-auto flex px-10 py-10 md:flex-row flex-col items-center">
                <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
                    <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
                        Hi, I'm Kalpak.
                        <br className="hidden lg:inline-block" />
                    </h1>
                    <p className="mb-8 leading-relaxed">
                        I am a Full Stack Developer. Trying to learn new technologies and contribute to open source projects as well as work with fellow developers. Check out the projects I've worked on below. Feel free to contact me.

                    </p>
                    <div className="flex justify-center flex-wrap">
                        {socials.map((social) => (
                            <a
                                href={social.link}
                                key={social.link}
                                target="_blank"
                                rel="noreferrer"
                                className="transition-all duration-500 inline-flex text-white border-0  m-3 px-3 py-2 focus:outline-none bg-slate-600  hover:bg-slate-400 hover:scale-110 rounded-full text-lg">
                                <img className="mr-2 rounded-lg" src={social.icon} alt={social.icon} style={{ maxWidth: "20px" }} />
                                {social.name}
                            </a>))}


                    </div>
                </div>
                <div className="lg:max-w-md lg:w-auto md:w-1/2 w-5/6">
                    <img
                        className="object-cover object-center rounded-full "
                        alt="hero"
                        src={img}

                    />
                </div>
            </div>
        </section>
    );
}